export enum DisplayModeEnum {
    Simple = "simple",
    Detailed = "detailed",
}

export enum KPIBannerKeyEnum {
    revenue = "global-inclvat",
    profit = "global-profit",
    efficiencyScore = "efficiency-score",
    roas = "roas",
    openRate = "open-rate",
    discountedOrders = "discounted-orders",
    discountPerOrder = "discount-per-order",
    roi = "roi",
    timeBalance = "time-balance",
    adSpentBudget = "ad-spent-budget",
    unfulfilledOrders = "unfulfilled-orders",
    // TODO: might conflict with glovo courier wait time KPI
    // courierWaitTime = "courier-wait-time",
    inaccurateOrders = "inaccurate-orders",
    conversionRate = "conversion-rate",
}
